import gravyAxios from "@/plugins/axios";

const authStore = {
    state: () => ({
        user: false,
        gravyUser: false,
        profilePicture: ''
    }),
    actions: {
        getGravyUser: async ({commit, dispatch}) => {
            let authResponse = null
            try {
                 authResponse = await gravyAxios.post('/user/login')
                 commit('setGravyUser', authResponse.data)
            } catch (e) {
               dispatch('createAlert', {
                   type: 'danger',
                   message: e
               })
            }
        },
        setProfilePicture: ({commit}, profilePicLink) => {
            commit('setProfilePicture', profilePicLink)
        }
    },
    mutations: {
        setUser: (state, user) => {
            state.user = user
        },
        setGravyUser: (state, user) => {
            state.gravyUser = user
        },
        setProfilePicture: (state, profilePicLink) => {
            state.profilePicture = profilePicLink;
        }
    },
    getters: {
    //     isLoggedIn: state => {
    //         firebase.auth().onAuthStateChanged((user) => {
    //             if (user) {
    //                 console.log(`User from Firebase: ${user}`)
    //                 state.user = user
    //             } else {
    //                 state.user = false
    //             }
    //         })
    //         return state.user
    //     },
        getUser: state => {
            return state.user
        },
        getGravyUser: state => {
            return state.gravyUser
        },
        getGravyUserRole: state => {
            return state.gravyUser.string
        },
        getProfilePicture: state => {
            return state.profilePicture;
        }
    }
}


export default authStore
